export default __webpack_public_path__ + "static/media/Joséphine Amina.74d67d3b.JPG";